// Translation files for English (UK) and Spanish
export const translations = {
  en: {
    // LaunchMenu translations
    launchMenu: {
      title: "PLD Space Cake Smash",
      description: "Navigate your rocket through space and hit the target to complete your mission!",
      playGame: "Play Game",
      disclaimer: "Prepare for an interstellar adventure!",
      nameLabel: "Name",
      namePlaceholder: "Enter your name",
      emailLabel: "Email",
      emailPlaceholder: "Enter your email address",
      questionPlaceholder: "Share your thoughts and ambitions...",
      continue: "Continue",
      back: "Back",
      submit: "Submit",
      submitting: "Submitting...",
      userInfoTitle: "Enter Your Details",
      userInfoSubtitle: "We'll use this information for your score and competition entry.",
      questionTitle: "Competition Question",
      questionSubtitle: "Answer this question to enter our competition!",
      questionLabel: "We want you to be part of the crew!\n\nDuring your first mission, you've proven yourself capable of taking the bull by the horns... but in PLD Space, the missions are getting bigger and bigger.\n\nHow high are you willing to go in PLD Space?",
      questionText: "Share your thoughts about space exploration...",
      thankYouMessage: "Thank you, {name}! You're all set to begin your mission.",
      playGameButton: "Play Game",
      emailInvalidError: "Please enter a valid email address",
      submitError: "Error submitting data. Please try again.",
      privacyPolicy: "I have read and accept the privacy policy",
      privacyPolicyRequired: "You must accept the privacy policy to continue"
    },
    
    // User Data Form (post-game)
    userDataForm: {
      title: "Share Your Achievement!",
      subtitle: "Congratulations on reaching level {level}! Share your score and enter our competition.",
      skip: "Skip"
    },
    
    // AdminPanel translations
    adminPanel: {
      loginTitle: "Admin Login",
      passwordPlaceholder: "Enter admin password",
      loginButton: "Login",
      incorrectPassword: "Incorrect password",
      adminRequired: "Admin access required",
      panelTitle: "Admin Panel",
      refreshButton: "Refresh",
      loadingButton: "Loading...",
      dateTimeHeader: "DATE/TIME",
      nameHeader: "NAME",
      emailHeader: "EMAIL",
      countryHeader: "COUNTRY",
      languageHeader: "LANGUAGE",
      deviceHeader: "DEVICE",
      osHeader: "OS",
      browserHeader: "BROWSER",
      answerHeader: "ANSWER",
      loadedSubmissions: "Loaded {count} submissions",
      refreshedSubmissions: "Refreshed {count} submissions",
      totalSubmissions: "Total submissions: {count}",
      noSubmissions: "No submissions found",
      downloadButton: "Download CSV",
      downloadSuccess: "Successfully downloaded {count} submissions!",
      exportTranslations: "Export Translations",
      translationsExported: "Translations exported successfully as {filename}",
      translationsExportError: "Failed to export translations: {error}",
      usageLabel: "Usage:",
      usageText: "Add ?admin=true to URL",
      securityLabel: "Security:",
      securityText: "Only accessible via URL parameter",
      expandPanel: "Expand panel",
      collapsePanel: "Collapse panel",
      permissionDeniedFix: "Fix: Update your Firestore rules to allow reads:",
      firestoreRule: "allow read: if true;"
    },

    // Common translations
    common: {
      loading: "Loading...",
      error: "Error",
      success: "Success"
    },

    // StoryBox translations
    storyBox: {
      heading: "Incoming Transmission",
      story1: "During our journey to Planet AdAstra, an unexpected asteroid field has diverted our route. Navigation systems are out of order, and the crew needs your help to continue.",
      story2: "We only have five fuel cells left. Every move counts. As a member of the AdAstra Early Talent Day crew, your mission is clear: land the MIURA successfully.",
      story3: "Aim high! But in this mission, all you need to do is align the quantum entanglement propulsion wave oscillator with the main collector of the central injectors...",
      story4: "Or simply hold down the <strong style='color: #ff2d3b;'>CHARGE</strong> button until the <strong style='color: #ff8c00;'>ORANGE</strong> bar is within the guide lines.",
      story5: "Reach level 8 and get a special discount for the PLD Space store. Good luck!",
      continueButton: "Play Game"
    },

    // Game UI translations
    gameUI: {
      level: "Level",
      fuelRemaining: "Fuel Remaining",
      fuelRemainingShort: "Fuel",
      charge: "Charge",
      cooling: "Cooling",
      levelComplete: "Level Complete!",
      hitCakeMessage: "You reached AdAstra in {attempts} attempt{plural}!",
      nextLevel: "Next Level",
      youMissed: "You missed!",
      tryAgain: "Try Again",
      missionComplete: "Mission Complete!",
      levelReached: "You reached Level {level}!",
      preparingResults: "Preparing your results..."
    },

    // Final screens translations
    finalScreens: {
      longPressTip: "Long press to save your badge",
      downloadBadge: "Download Your Badge",
      visitShop: "Visit The Shop",
      playAgain: "Play Again",
      longPressInstruction: "Long press the image to save"
    },

    // Congratulations/Discount translations
    congratulations: {
      title: "CONGRATULATIONS!",
      discountText: "You have unlocked a 15% discount at our store* Use the promocode below:",
      promoCode: "Ad15traEarlyTalent",
      applicable: "*Applicable until 18/10/25 at 11:59 p.m. CEST",
      voucherOnce: "*The voucher can be used only once per person"
    },

    // Badge translations
    badge: {
      level: "Level ",
      misses: "Misses: ",
      achievement12: "You are the best of the best. A Top Gun pilot!",
      achievement10: "Incredible performance! You should be proud of your achievement.",
      achievement7: "Welcome to the danger zone. That flight puts you in the cockpit with the best of them!",
      achievement4: "You didn't quite make it to the danger zone, but you gave it a valiant effort.",
      achievement1: "You may need to go back to the academy, Cadet.",
      percent12: "Only 2% of players reach level 12.",
      percent10: "Only 12% of players reach this level!",
      percent7: "Only 32% of players reach level 7 or above.",
      percent4: "Only 62% of players reach level 4 or above.",
      percent1: "You've joined the 100% of players who tried!"
    }
  },

  es: {
    // LaunchMenu translations (Spanish)
    launchMenu: {
      title: "PLD Space Cake Smash",
      description: "¡Navega tu cohete por el espacio y golpea el objetivo para completar tu misión!",
      playGame: "Jugar",
      disclaimer: "¡Prepárate para una aventura interestelar!",
      nameLabel: "Nombre",
      namePlaceholder: "Introduce tu nombre",
      emailLabel: "Correo electrónico",
      emailPlaceholder: "Introduce tu dirección de correo",
      questionPlaceholder: "Comparte tus pensamientos y ambiciones...",
      continue: "Continuar",
      back: "Atrás",
      submit: "Enviar",
      submitting: "Enviando...",
      userInfoTitle: "Introduce tus Datos",
      userInfoSubtitle: "Usaremos esta información para tu puntuación y entrada al concurso.",
      questionTitle: "Pregunta del Concurso",
      questionSubtitle: "¡Responde esta pregunta para participar en nuestro concurso!",
      questionLabel: "¡Queremos que formes parte de la tripulación!\n\nDurante tu primera misión has demostrado ser capaz de coger al toro por los cuernos... pero en PLD Space las misiones cada vez apuntan más alto.\n\n¿Cómo de alto estás dispuesto a llegar en PLD Space?",
      questionText: "Comparte tus pensamientos sobre la exploración espacial...",
      thankYouMessage: "¡Gracias, {name}! Todo está listo para comenzar tu misión.",
      playGameButton: "Jugar",
      emailInvalidError: "Por favor, introduce una dirección de correo válida",
      submitError: "Error al enviar los datos. Por favor, inténtalo de nuevo.",
      privacyPolicy: "He leído y acepto la política de privacidad",
      privacyPolicyRequired: "Debes aceptar la política de privacidad para continuar"
    },
    
    // User Data Form (post-game) - Spanish
    userDataForm: {
      title: "¡Comparte tu Logro!",
      subtitle: "¡Felicidades por alcanzar el nivel {level}! Comparte tu puntuación y participa en nuestro concurso.",
      skip: "Omitir"
    },
    
    // AdminPanel translations (Spanish)
    adminPanel: {
      loginTitle: "Acceso de Administrador",
      passwordPlaceholder: "Introduce la contraseña de administrador",
      loginButton: "Iniciar sesión",
      incorrectPassword: "Contraseña incorrecta",
      adminRequired: "Se requiere acceso de administrador",
      panelTitle: "Panel de Administración",
      refreshButton: "Actualizar",
      loadingButton: "Cargando...",
      dateTimeHeader: "FECHA/HORA",
      nameHeader: "NOMBRE",
      emailHeader: "CORREO",
      countryHeader: "PAÍS",
      languageHeader: "IDIOMA",
      deviceHeader: "DISPOSITIVO",
      osHeader: "SO",
      browserHeader: "NAVEGADOR",
      answerHeader: "RESPUESTA",
      loadedSubmissions: "Cargadas {count} respuestas",
      refreshedSubmissions: "Actualizadas {count} respuestas",
      totalSubmissions: "Total de respuestas: {count}",
      noSubmissions: "No se encontraron respuestas",
      downloadButton: "Descargar CSV",
      downloadSuccess: "¡{count} respuestas descargadas exitosamente!",
      exportTranslations: "Exportar Traducciones",
      translationsExported: "Traducciones exportadas exitosamente como {filename}",
      translationsExportError: "Error al exportar traducciones: {error}",
      usageLabel: "Uso:",
      usageText: "Añade ?admin=true a la URL",
      securityLabel: "Seguridad:",
      securityText: "Solo accesible vía parámetro URL",
      expandPanel: "Expandir panel",
      collapsePanel: "Contraer panel",
      permissionDeniedFix: "Solución: Actualiza las reglas de Firestore para permitir lecturas:",
      firestoreRule: "allow read: if true;"
    },

    // Common translations (Spanish)
    common: {
      loading: "Cargando...",
      error: "Error",
      success: "Éxito"
    },

    // StoryBox translations (Spanish)
    storyBox: {
      heading: "Transmisión Entrante",
      story1: "Durante la travesía hacia el Planeta AdAstra, un inesperado campo de asteroides ha desviado nuestra ruta. Los sistemas de navegación están fuera de servicio, y la tripulación necesita un nuevo tripulante que coja los mandos.",
      story2: "Solo contamos con cinco pilas de combustible. Cada movimiento cuenta. Como miembro de la tripulación de AdAstra Early Talent Day, tu misión es clara: aterrizar el MIURA con éxito.",
      story3: "¡Apunta alto! Pero en esta misión basta con alinear el oscilador de onda de propulsión de entrelazamiento cuántico con el colector principal de los inyectores centrales...",
      story4: "O simplemente mantén pulsado el botón <strong style='color: #ff2d3b;'>CARGAR</strong> hasta que la barra <strong style='color: #ff8c00;'>NARANJA</strong> esté dentro de las líneas de guiado.",
      story5: "Demuestra que eres capaz de llegar el nivel 8 y obtén un descuento especial para la tienda de PLD Space ¡Buena suerte!",
      continueButton: "Jugar"
    },

    // Game UI translations (Spanish)
    gameUI: {
      level: "Nivel",
      fuelRemaining: "Combustible Restante",
      fuelRemainingShort: "Combustible",
      charge: "Cargar",
      cooling: "Enfriando",
      levelComplete: "¡Nivel Completado!",
      hitCakeMessage: "Has aterrizado en {attempts} intento{plural}!",
      nextLevel: "Siguiente Nivel",
      youMissed: "Ups...¡has fallado!",
      tryAgain: "Intentar de Nuevo",
      missionComplete: "¡Misión Completada!",
      levelReached: "¡Alcanzaste el Nivel {level}!",
      preparingResults: "Preparando tus resultados..."
    },

    // Final screens translations (Spanish)
    finalScreens: {
      longPressTip: "Mantén presionado para guardar tu insignia",
      downloadBadge: "Descargar Tu Insignia",
      visitShop: "Visitar La Tienda",
      playAgain: "Jugar de Nuevo",
      longPressInstruction: "Mantén presionada la imagen para guardar"
    },

    // Congratulations/Discount translations (Spanish)
    congratulations: {
      title: "¡FELICIDADES!",
      discountText: "Has desbloqueado un 15% de descuento en nuestra tienda* Usa el código promocional a continuación:",
      promoCode: "Ad15traEarlyTalent",
      applicable: "*Aplicable hasta el sábado 18 de octubre a las 23h59. CEST",
      voucherOnce: "*El cupón se puede usar solo una vez por persona"
    },

    // Badge translations (Spanish)
    badge: {
      level: "Nivel ",
      misses: "Fallos: ",
      achievement12: "¡Eres el mejor de los mejores. Un piloto Top Gun!",
      achievement10: "¡Rendimiento increíble! Deberías estar orgulloso de tu logro.",
      achievement7: "¡Bienvenido a la zona de peligro. Ese vuelo te pone en la cabina con los mejores!",
      achievement4: "No llegaste del todo a la zona de peligro, pero hiciste un esfuerzo valiente.",
      achievement1: "Puede que necesites volver a la academia, Cadete.",
      percent12: "Solo el 2% de los jugadores alcanzan el nivel 12.",
      percent10: "¡Solo el 12% de los jugadores alcanzan este nivel!",
      percent7: "Solo el 32% de los jugadores alcanzan el nivel 7 o superior.",
      percent4: "Solo el 62% de los jugadores alcanzan el nivel 4 o superior.",
      percent1: "¡Te has unido al 100% de jugadores que lo intentaron!"
    }
  }
};

// Helper function to get nested translation with variable replacement
export const getTranslation = (translations, key, variables = {}) => {
  const keys = key.split('.');
  let value = translations;
  
  for (const k of keys) {
    value = value?.[k];
    if (value === undefined) {
      return key; // Return the key if translation not found
    }
  }
  
  // Replace variables in the translation
  if (typeof value === 'string' && Object.keys(variables).length > 0) {
    return value.replace(/\{(\w+)\}/g, (match, variableName) => {
      return variables[variableName] !== undefined ? variables[variableName] : match;
    });
  }
  
  return value;
};